import { createSelector } from '@reduxjs/toolkit';
import { denormalize } from 'normalizr';
import { Group, Selector } from 'shared/Redux/interfaces';
import { groupsEntity } from 'shared/Redux/schemas';
import { groupSelectors, unitSelectors } from 'shared/Redux/slices';

export default function selectGroupById(id: string): Selector<Group> {
  return createSelector(
    [groupSelectors.selectEntities, unitSelectors.selectEntities],
    (groups, units) => {
      const group = groups[id];
      const denormalized = denormalize(group, groupsEntity, {
        groups,
        units
      });

      return denormalized;
    }
  );
}
